
import {jsonParser} from 'components/Assistant/hooks/parser';
import {useState} from 'components/Assistant/hooks/reducer';
import {Assistant} from 'components/Assistant/hooks/types';

import {useSendUser} from './query';

export const useInterviewer = (subject: string): Assistant => {
	const [state, dispatch] = useState(jsonParser);
	const [send] = useSendUser(dispatch);

	return {
		state,
		send: (message: string) => {
			const minNext = (state.counter || 0) + 1;
			const counter = Math.max(minNext, Number(new Date()));

			// Update our local reducer with our pending state
			dispatch({
				type: 'SEND',
				message,
				counter,
			});

			// Send an API query, need the latest to return to
			// update/resolve our API state
			send({
				context: {
					counter,
					slowQuery: 'super-slow',
				},
				variables: {
					id: state.id,
					message,
					subject,
				},
			});
		},
	};
};
